import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  /** Стек областей фокуса, с активной областью наверху */
  var stack = [];
  return {
    add: function add(focusScope) {
      // приостановить текущую активную область фокуса (наверху стека)
      var activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      }
      // удалить в случае, если она уже существует (потому что мы добавим её снова наверх стека)
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove: function remove(focusScope) {
      var _stack$;
      stack = arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function arrayRemove(array, item) {
  var updatedArray = _toConsumableArray(array);
  var index = updatedArray.indexOf(item);
  if (index !== -1) {
    updatedArray.splice(index, 1);
  }
  return updatedArray;
}
export function removeLinks(items) {
  return items.filter(function (item) {
    return item.tagName !== 'A';
  });
}